<nav class="navbar navbar-expand-lg navbar-light">
  <a class="bd_logo" routerLink=""
    ><img src="assets/img/logo.png" alt="Logo" /><span>Tea InnTech1</span></a
  >

  <div
    class="collapse navbar-collapse mob_nav d-none"
    id="navbarSupportedContent"
  >
    <ul class="navbar-nav mx-auto bd_menu">
      <li
        *ngFor="let item of menu"
        class="nav-item dropdown"
        routerLinkActive="active"
      >
        <a
          class="nav-link"
          [class]="item.submenu?.length ? 'dropdown-toggle' : ''"
          [routerLink]="item.href"
          >{{ item.label }}</a
        >
        <ul
          *ngIf="item.submenu?.length"
          class="dropdown-menu"
          [class.show]="classToggled"
        >
          <li *ngFor="let subitem of item.submenu">
            <a
              class="dropdown-item"
              [routerLink]="[item.href]"
              fragment="{{ subitem.href }}"
            >
              {{ subitem.label }}
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>

  <form action="login.html" id="login_type" method="post">
    <div class="rgt_log">
      <ng-container *ngIf="authService.userLoggedIn()">
        <a href="javascript:void(0)" (click)="redirectDashboard()">Dashboard</a>
      </ng-container>

      <ng-container *ngIf="!authService.userLoggedIn()">
        <form [formGroup]="loginSelectorForm" class="d-flex">
          <div class="log_slect">
            <select formControlName="role">
              <option value="{{ role.value }}" *ngFor="let role of roleMaster">
                As a {{ role.label }}
              </option>
            </select>
          </div>
          <a href="javascript:;" (click)="loginClicked()">Login</a>
        </form>
      </ng-container>
    </div>
  </form>
  <button
    class="navbar-toggler bd_toggle"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
</nav>
